import Navbar from './components/Navbar'
import Home from './Pages/Home'
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Navbar/>
      <Home/>
      <Footer/>
      </div>
  );
}

export default App;
